import { getWpCaption } from "../adrUtilsV3";

// Interface
const adrTaPdfSectionDataV3 = {
  headerData,
  laborData,
  equipmentData,
  materialsData,
};

function headerData(adr, feederLists, ta, version) {
  const {
    jobStamp,
    projContractorList,
    projItemList,
    projCcoList,
    projPendingIssueList,
  } = feederLists;
  const wp = adr.workPerformedClient[ta.wpTabId];

  /** @type {number[]} */
  const selectedContractorIds =
    ta && ta.contractors ? ta.contractors.map((tac) => tac.contractorId) : [];

  /** @type {string[]} */
  const contractors = (projContractorList || [])
    .filter((c) => selectedContractorIds.includes(c.contractorId))
    .map((c) => c.name);

  const headerData = {
    version,
    fullEA: jobStamp ? jobStamp.fullEA : "(EA N/A)",
    wpCaption: wp
      ? getWpCaption(wp, projItemList, projCcoList, projPendingIssueList)
      : "(N/A)",
    contractors,
    workDescription: ta.workDescription,
    workLocation: "",
  };

  return headerData;
}

function laborData(adr, feederLists) {}

function equipmentData(adr, feederLists) {}

function materialsData(adr) {}

export default adrTaPdfSectionDataV3;
